import { render } from "./page-header.md?vue&type=template&id=19eb5a34"
import script from "./page-header.md?vue&type=script&lang=js"
export * from "./page-header.md?vue&type=script&lang=js"
script.render = render

export default script